import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

// Existing model imports

class AppConfigApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async GetApplicationConfig(): Promise<any> {
    try {
      const response = await this.api.get<any>("/common/getApplicationConfig");
      return response.data;
    } catch (error) {
      console.error("GetApplicationConfig error:", error);
      throw error;
    }
  }

  public async SetApplicationConfig(conf: any) {
    try {
      console.log("Setting Application Config:", conf);
      const response = await this.api.post<any>(
        "/adminPanel/setApplicationConfig",
        { conf }
      );
      return response.data;
    } catch (error) {
      console.error("SetApplicationConfig error:", error);
      throw error;
    }
  }
}

export const AppConfigApis = new AppConfigApiService();
